import { PDComment } from 'views/timesheet/project-managers-timesheets/components/pd-comment';

export const PDComments = ({ comment, entryPerActivityId,isMaster}) => {
  return <PDComment initialComment={comment} tpaid={entryPerActivityId} isMaster={isMaster} />;
};
